<template>
  <div>
    <div class="row m-0">
      <div class="col-md-12 text-center">
        <h6 class="title-pages">RECEBER LANÇAMENTO(S) SELECIONADO(S)</h6>
      </div>
      <div class="col-md-12 pt-0 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 text-right">
        <v-btn
          class="btn-save btn-block"
          :disabled="loading"
          :loading="loading"
          @click="execute"
        >
          <i class="fas fa-check mr-2"></i>
          RECEBER
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import api from "../../../../../services/api";

import routes from "../../../../../routes";

import toast from "../../../../../lib/ToastNotification";

export default {
  name: "Execute",

  components: { ErrorsMessages },

  props: {
    service_ids: Array,
    stock_sale_ids: Array,
  },

  data() {
    return {
      resident_id: "",

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;
    },

    async execute() {
      try {
        this.loading = true;

        const { resident_id, service_ids, stock_sale_ids } = this;

        let params = { resident_id, service_ids, stock_sale_ids };

        const response = await api.post("/rest-home/family/release", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];
          this.$bvModal.hide("execute");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
